<div class="float-right d-none d-sm-block"></div>
<div class="row">
<div class="col-lg-6">
    <p class="mb-0 josefin-sans-regular">&copy; <b>{{ currentYear }}</b> All rights reserved to
        <a href="https://cktechsoln.in/" class="text-black text-decoration-none josefin-sans-bold">CKTech Solution Pvt Ltd Madurai</a>.
    </p>
</div>
<div class="col-lg-6 justify-content-end align-items-end text-end">
    <p class="mb-0 josefin-sans-regular">Designed & Developed by
        <a href="https://cktechsoln.in/" target="_blank"
            class="text-black text-decoration-none josefin-sans-bold">CKTech Solution Pvt Ltd Madurai.</a>
    </p>
</div>
</div>